// extracted by mini-css-extract-plugin
export default {"chart-container":"LogsStats_chart-container__QBXWO","data-type-graph-dropdown":"LogsStats_data-type-graph-dropdown__8g0kz"};